import {
  DynamicBlock as DynamicBlockType,
  Image,
} from '@tribeplatform/gql-client/types'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { Icon, SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export const AddDynamicBlocksSidebarItem = ({
  dynamicBlock,
  onClick,
}: {
  dynamicBlock: DynamicBlockType
  onClick: () => void
}) => {
  const iconUrl = ((dynamicBlock?.favicon ?? dynamicBlock?.image) as Image)?.url

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full py-2 px-5 truncate hover:bg-action-primary hover:text-content-on-primary"
    >
      <div className="flex flex-grow items-center gap-1">
        <Icon size="lg">
          {iconUrl ? (
            <Avatar
              size="lg"
              rounded="sm"
              name={dynamicBlock.name}
              src={iconUrl}
              className="flex"
            />
          ) : (
            <SvgIcon name="block" />
          )}
        </Icon>
        <div className="flex-grow text-start truncate">{dynamicBlock.name}</div>
      </div>
    </button>
  )
}
